import { Employee, Notification, Tool } from '../types';

export function syncToolAssignmentsFromTeams(tool: Tool, employees: Employee[]): Tool {
  if (!tool.teams?.length) return tool;
  const idsFromTeams = employees
    .filter((employee) => employee.team && tool.teams?.includes(employee.team))
    .map((employee) => employee.id);
  const merged = [...new Set([...(tool.assignedUserIds || []), ...idsFromTeams])];
  return { ...tool, assignedUserIds: merged };
}

export function createAccessProvisionNotification(employee: Employee, tool: Tool): Notification {
  return {
    id: crypto.randomUUID(),
    type: 'OWNER_TASK',
    status: 'PENDING',
    requesterId: employee.id,
    requesterName: employee.name,
    createdAt: new Date().toISOString(),
    toolId: tool.id,
    toolName: tool.name,
    accessReason: `Grant access to ${employee.name} for ${tool.name}.`,
  };
}

export function createRevokeAccessNotification(employee: Employee, tool: Tool): Notification {
  return {
    id: crypto.randomUUID(),
    type: 'OWNER_TASK',
    status: 'PENDING',
    requesterId: employee.id,
    requesterName: employee.name,
    createdAt: new Date().toISOString(),
    toolId: tool.id,
    toolName: tool.name,
    accessReason: `Revoke access for ${employee.name} from ${tool.name}.`,
  };
}

export function hasPendingAccessTaskFor(notifications: Notification[], toolId: string, employeeId: string): boolean {
  return notifications.some(
    (notification) =>
      notification.type === 'OWNER_TASK' &&
      notification.status === 'PENDING' &&
      notification.toolId === toolId &&
      notification.requesterId === employeeId &&
      notification.accessReason?.startsWith('Grant access') === true
  );
}

export function hasPendingRevokeTaskFor(notifications: Notification[], toolId: string, employeeId: string): boolean {
  return notifications.some(
    (notification) =>
      notification.type === 'OWNER_TASK' &&
      notification.status === 'PENDING' &&
      notification.toolId === toolId &&
      notification.requesterId === employeeId &&
      notification.accessReason?.startsWith('Revoke access')
  );
}

export function mergeMissingTags(existingTags: string[], toolTags: string[]): string[] {
  const existingSet = new Set(existingTags);
  const newTags = toolTags.filter((tag) => !existingSet.has(tag));
  if (newTags.length === 0) return existingTags;
  return [...existingTags, ...newTags];
}
